/* Pashion Wishlist System */
(function() {
  'use strict';

  const STORAGE_KEY = 'pashion_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch(e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent('pashion:wishlist:updated', { detail: { list } }));
  }

  function isInWishlist(productId) {
    return getWishlist().some(item => item.id === productId);
  }

  function addToWishlist(product) {
    const list = getWishlist();
    if (!list.some(item => item.id === product.id)) {
      list.push(product);
      saveWishlist(list);
    }
  }

  function removeFromWishlist(productId) {
    const list = getWishlist().filter(item => item.id !== productId);
    saveWishlist(list);
  }

  function toggleWishlist(product) {
    if (isInWishlist(product.id)) {
      removeFromWishlist(product.id);
      return false;
    } else {
      addToWishlist(product);
      return true;
    }
  }

  function updateWishlistCount() {
    const count = getWishlist().length;
    document.querySelectorAll('[data-pashion-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function initWishlistButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      const productId = btn.dataset.wishlistToggle;
      if (!productId) return;
      
      if (isInWishlist(productId)) {
        btn.classList.add('active');
        btn.setAttribute('aria-label', 'Retirer des favoris');
      } else {
        btn.classList.remove('active');
        btn.setAttribute('aria-label', 'Ajouter aux favoris');
      }

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const product = {
          id: productId,
          title: btn.dataset.wishlistTitle || '',
          price: btn.dataset.wishlistPrice || '',
          url: btn.dataset.wishlistUrl || '',
          image: btn.dataset.wishlistImage || '',
          vendor: btn.dataset.wishlistVendor || ''
        };
        const added = toggleWishlist(product);
        btn.classList.toggle('active', added);
        btn.setAttribute('aria-label', added ? 'Retirer des favoris' : 'Ajouter aux favoris');
        
        // Toast notification
        showToast(added ? 'Ajouté aux favoris' : 'Retiré des favoris');
        updateWishlistCount();
      });
    });
  }

  function showToast(message) {
    let toast = document.getElementById('pashion-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'pashion-toast';
      toast.style.cssText = 'position:fixed;bottom:32px;left:50%;transform:translateX(-50%) translateY(20px);background:#0a0a0a;color:#f5f5f5;padding:12px 28px;font-family:Space Grotesk,sans-serif;font-size:12px;font-weight:600;letter-spacing:0.15em;text-transform:uppercase;z-index:9999;opacity:0;transition:all 0.3s ease;pointer-events:none;clip-path:polygon(0 0,calc(100% - 6px) 0,100% 6px,100% 100%,6px 100%,0 calc(100% - 6px));';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.style.opacity = '1';
    toast.style.transform = 'translateX(-50%) translateY(0)';
    clearTimeout(toast._timeout);
    toast._timeout = setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(-50%) translateY(20px)';
    }, 2200);
  }

  // Render wishlist page
  function renderWishlistPage() {
    const container = document.getElementById('pashion-wishlist-products');
    if (!container) return;
    
    const list = getWishlist();
    const emptyState = document.getElementById('pashion-wishlist-empty');
    const grid = document.getElementById('pashion-wishlist-grid');
    
    if (list.length === 0) {
      if (emptyState) emptyState.style.display = 'block';
      if (grid) grid.style.display = 'none';
      return;
    }
    
    if (emptyState) emptyState.style.display = 'none';
    if (grid) grid.style.display = 'grid';
    
    container.innerHTML = list.map(product => `
      <div class="pashion-product-card" data-product-id="${product.id}">
        <div class="pashion-product-card__img-wrap">
          <a href="${product.url}">
            ${product.image ? `<img class="pashion-product-card__img" src="${product.image}" alt="${product.title}" loading="lazy">` : '<div class="pashion-product-card__img" style="background:#e8e8e8;"></div>'}
          </a>
          <button class="pashion-product-card__wish active" 
            data-wishlist-toggle="${product.id}"
            data-wishlist-title="${product.title}"
            data-wishlist-price="${product.price}"
            data-wishlist-url="${product.url}"
            data-wishlist-image="${product.image}"
            data-wishlist-vendor="${product.vendor}"
            aria-label="Retirer des favoris">
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 21.593c-5.63-5.539-11-10.297-11-14.402 0-3.791 3.068-5.191 5.281-5.191 1.312 0 4.151.501 5.719 4.457 1.59-3.968 4.464-4.447 5.726-4.447 2.54 0 5.274 1.621 5.274 5.181 0 4.069-5.136 8.625-11 14.402z"/></svg>
          </button>
        </div>
        <div class="pashion-product-card__info">
          <div class="pashion-product-card__vendor">${product.vendor}</div>
          <h3 class="pashion-product-card__name">${product.title}</h3>
          <div class="pashion-product-card__price-row">
            <span class="pashion-product-card__price">${product.price}</span>
          </div>
        </div>
        <a href="${product.url}" class="pashion-product-card__quick-add">Voir le produit</a>
      </div>
    `).join('');
    
    initWishlistButtons();
    
    // Listen for removals to re-render
    window.addEventListener('pashion:wishlist:updated', renderWishlistPage);
  }

  // Init on DOM ready
  function init() {
    initWishlistButtons();
    updateWishlistCount();
    renderWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pashion:wishlist:updated', () => {
    updateWishlistCount();
  });

  // Public API
  window.PashionWishlist = { getWishlist, addToWishlist, removeFromWishlist, isInWishlist, toggleWishlist };
})();
